import { useFeatureFlags as useFeatureFlagsProvider } from '../providers/FeatureFlagsProvider'

export const useFeatureFlags = (...flags) => {
  const { features } = useFeatureFlagsProvider()

  return Object.keys(features)
    .filter(flag => flags.includes(flag))
    .reduce((allFeatures, flag) => ({ ...allFeatures, [flag]: features[flag] }), {})
}
